import React from 'react'
import DateFormat from '../../../../shared/helpers/date-format'
import classNames from 'classnames'
import Tooltip from './tooltip'
import scrolling from '../../../../utils/scrolling'
import randomId from '../../../../utils/random-id'
import Region from '../../../../shared/components/region'
import { DateTime } from 'luxon'

let { fancyFull, machineTime, time } = DateFormat

class Event extends React.PureComponent {
  rootRef = React.createRef()
  buttonRef = React.createRef()
  tooltipRef = React.createRef()
  tooltipId = randomId()

  state = {
    tooltipVisible: false
  }

  componentDidUpdate() {
    // large breakpoint
    if (window.matchMedia('(max-width: 60em)').matches) {
      if (this.state.tooltipVisible && !scrolling.locked) {
        scrolling.lock()
      } else if (!this.state.tooltipVisible && scrolling.locked) {
        scrolling.unlock()
      }
    }
  }

  render() {
    let { event, position } = this.props
    let date = DateTime.fromISO(event.time, { zone: 'America/Chicago' })
    let hasImage = !!event.thumbnailPhoto.small
    let formattedMachineTime = machineTime(date)
    let formattedTime = time(date, true).toLowerCase()
    let formattedDateTime = fancyFull(date)
    let classes = classNames(
      'bg-white my-8 shadow w-full text-left',
      {
        'flex overflow-hidden justify-between items-start lg:block':
          hasImage
      }
    )

    return (
      <Region
        innerRef={this.rootRef}
        className="w-full md:relative"
        onEscape={this.handleEscape}
        onFocusOut={this.handleFocus}
        onClickOutside={this.handleClickOutside}
      >
        <button
          ref={this.buttonRef}
          className={classes}
          onClick={this.toggleTooltip}
        >
          {hasImage && (
            <img
              src={event.thumbnailPhoto.small}
              className="w-100-fixed lg:w-full order-1 m-8 lg:m-0"
              alt=""
            />
          )}

          <div className="p-8">
            <time
              dateTime={formattedMachineTime}
              className="block font-bold text-11 text-depths mb-8"
            >
              <span aria-hidden="true">{formattedTime}</span>
              <span className="sr-only">
                {formattedDateTime + ' at ' + formattedTime}
              </span>
            </time>

            <span className="block text-14">{event.title}</span>

            {event.location_name && (
              <span className="block font-bold text-11 uppercase mt-8">
                {event.location_name}
              </span>
            )}
            <span className="sr-only">. more info</span>
          </div>
        </button>

        <Tooltip
          id={`event-${this.tooltipId}`}
          event={event}
          innerRef={this.tooltipRef}
          visible={this.state.tooltipVisible}
          machineTime={formattedMachineTime}
          date={date}
          time={formattedTime}
          dateTime={formattedDateTime}
          onDismiss={this.hideTooltip}
          direction={position < 2 ? 'right' : 'left'}
        />
      </Region>
    )
  }

  handleEscape = e => this.hideTooltipAndReturnFocus(e)

  handleFocus = e => this.hideTooltipAndReturnFocus(e)

  handleClickOutside = e => this.hideTooltipAndReturnFocus(e)

  hideTooltipAndReturnFocus = e => {
    if (this.state.tooltipVisible) {
      this.hideTooltip()
      e.preventDefault()
      e.stopPropagation()
    }
  }

  toggleTooltip = () => {
    this.setState(({ tooltipVisible }) => ({
      tooltipVisible: !tooltipVisible
    }))
  }

  hideTooltip = () => {
    this.setState({ tooltipVisible: false })
  }
}

export default Event
